<template lang="pug">
  include /mixins
  resource-loader-controller(
    :resource='$options.getOrderSpecialOfferList'
    :immediate='true'
  )
    template(
      #default='{ receive, result, loading }'
    )
      div()
        div(v-if='result && result.length')
          tag(
            :tag='offer_config.tag'
            v-model='form[offer_config.name]'
            :input-label='offer_config.title',
            :rules='offer_config.rules'
            v-bind='offer_config.props'
            :name='offer_config.name'
            :options='[defaultValue, ...result]'
            :custom-label='r => r.props && r.props.title'
            @input='handleTypeChange(form[offer_config.name])'
          )
          +b.ds-panel
            +e.element--offset_vertical
              +e.element--offset_vertical.--indent_inside
                +b.ds-caption--size_sm.P {{ _('Если вы участвуете в закупке под спецпредложения, то поставьте галочку и наш менеджер свяжется с вами для уточнения') }}
          //- v-selection-controller(
          //-   :options='result'
          //-   :multiple='true',
          //-   :key-getter="$options.keyGetter",
          //-   v-model='type'
          //-   ref='controller'
          //-   v-slot="{ options, value: model, change }"
          //- )
          //-   validation-provider(
          //-     v-slot="{ errors, classes }"
          //-     name='special_offer'
          //-   )
          //-     div
          //-       +b.um-space_mt--3
          //-         +b.d-control-static-input--appearance_inline.TAG(
          //-           :rules='{ required: { allowFalse: false } }',
          //-           :tag='"input"'
          //-           :input-label='_("Не участвую")'
          //-           :key='`key_without_special_offer`'
          //-           v-model='model'
          //-           :checked.props='model.find(e => e && e.id == defaultValue.id)'
          //-           :id='`special_offer_without_special_offer`'
          //-           :ref='`special_offer_without_special_offer`'
          //-           @change='change(defaultValue); clearOther(model, options); $emit("input", type)'
          //-           type='checkbox'
          //-           name='special_offer'
          //-         )
          //-         label.input-group__input(
          //-           :for='`special_offer_without_special_offer`'
          //-         ) {{ defaultValue.props.title }}
          //-       +b.um-space_mt--3(v-for='{ value } in options')
          //-         +b.d-control-static-input--appearance_inline.TAG(
          //-           :rules='{ required: { allowFalse: false } }',
          //-           :tag='"input"'
          //-           :checked.props='!!model.find(e => e && e.id == value.id)'
          //-           :input-label='value.props.title'
          //-           :key='`key_${value.id}`'
          //-           v-model='model'
          //-           :id='`special_offer_${value.id}`'
          //-           :ref='`special_offer_${value.id}`'
          //-           @change='change(value);  clearDefault(model, options); $emit("input", type)'
          //-           type='checkbox'
          //-           name='special_offer'
          //-         )
          //-         label.input-group__input(
          //-           :for='`special_offer_${value.id}`'
          //-         ) {{ value.props.title }}
</template>

<script>

import {
  getOrderSpecialOfferList,
} from '@api/order.service'

const DEFAULT_TYPE = 'default'

export default {
  name: 'OrderSpecialOffersList',
  getOrderSpecialOfferList,
  keyGetter: x => `${x.type}:${x.id}`,
  data() {
    return {
      defaultValue: {
        type: 'order.specialofferorderoption',
        id: DEFAULT_TYPE,
        props: { title: this._('Не участвую') },
      },
      type: [],
      offer_config: {
        size: '12',
        title: this._('payment service'),
        rules: 'required',
        name: 'type',
        tag: 'd-control-multiselect',
        events: {
          input: (model, options) => this.submit(model, options),
        },
        props: {
          options: [],
          label: 'caption',
          customLabel: x => x.props.title,
          multiple: true,
          trackBy: 'id',
        },
      },
      form: {
        type: {},
      },
      state: [],
    }
  },
  mounted() {
    this.type.push(this.defaultValue)
    this.offer_config.props.options = this.type
    this.form.type = this.type
    this.state = [...this.type]
  },
  methods: {
    clearOther(model, options) {
      // if (this.form.type.find(e => e && e.id === this.defaultValue.id)) {
      //   options.forEach(x => {
      //     this.$refs[`special_offer_${x.value.id}`][0].checked = false
      //   })
      // }
      console.log('clearOTHER');
      this.form.type = [this.defaultValue]
    },
    clearDefault() {
      const i = this.form.type.findIndex(e => e.id === this.defaultValue.id)
      console.log(i);
      console.log('clearDEFAULT');
      if (0 <= i) {
        this.form.type.splice(i, 1)
        // this.$refs.special_offer_without_special_offer.checked = false
      }
    },
    savePrevState() {
      this.state = [...this.form.type]
    },
    handleTypeChange(model) {
      const hasDefault = model.some(e => e && e.id === this.defaultValue.id)
      const hadDefault = this.state.some(e => e && e.id === this.defaultValue.id)

      let nextValue = []

      if (hasDefault && model.length > 1) {
        if (hadDefault) {
          // було default, потім вибрали інший - треба прибрати default
          nextValue = model.filter(e => e && e.id !== this.defaultValue.id)
        } else {
          // не було default, але його щойно вибрали - лишаємо тільки default
          nextValue = [this.defaultValue]
        }
      } else if (!hasDefault && model.length) {
        nextValue = model
      } else {
        nextValue = [this.defaultValue]
      }

      this.type = [...nextValue]
      this.form.type = [...nextValue]
      this.savePrevState()
    }
  },
}
</script>
